import type { FlexContainerAutoLinkProps } from "./flex-container-auto-link.type";

import { Typography } from "antd";

import FlexContainer from "../flex-container.component";

import { getAutoLinkMatchs } from "./flex-container-auto-link.helper";

const { Text, Link } = Typography;

const FlexContainerAutoLink = ({
  value,
  ...containerProps
}: FlexContainerAutoLinkProps) => {
  let content = undefined;
  if (value) {
    const matchs = getAutoLinkMatchs(value);
    content = matchs ? (
      <Text>
        {value.split(matchs[0])[0]}
        <Link href={matchs[0]} target="_blank">
          {matchs[0]}
        </Link>
        {value.split(matchs[0])[1]}
      </Text>
    ) : (
      <Text>{value}</Text>
    );
  }
  return <FlexContainer {...containerProps} value={content} />;
};

export default FlexContainerAutoLink;
